import { normalizePath, timecode } from '../lib/format';
import type { Comment, Item } from '../lib/types';
import type { IconName } from '../components/Icon';

/** Short label describing where a comment points, for list views. */
export function locationOf(comment: Comment, item?: Item | null): { icon: IconName; label: string } | null {
  const a = comment.anchor;
  if (a.type === 'dom') {
    const device: IconName = a.viewport === 'mobile' ? 'smartphone' : a.viewport === 'tablet' ? 'tablet' : 'monitor';
    return { icon: device, label: normalizePath(a.pagePath) };
  }
  if (a.type === 'time') return { icon: 'clock', label: timecode(a.time) };
  const version = item?.versions?.find((v) => v.id === comment.versionId);
  const suffix = version && item?.versions && item.versions.length > 1 ? ` · v${version.versionNo}` : '';
  if (a.type === 'point') return { icon: 'pin', label: `Pin${suffix}` };
  if (a.type === 'region') return { icon: 'region', label: `Area${suffix}` };
  return item ? { icon: 'message', label: 'General' } : null;
}
